export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export interface SortParameter {
  sortBy: string;
  direction: SortDirection;
}

export abstract class SortService {
  static sortByMultiple(items: any[], sortParameter: SortParameter[]): any[] {
    return items.sort((a, b) => {
      for (const sortParam of sortParameter) {
        const sortByAttr = sortParam.sortBy;
        const compareResult = SortService.compare(
          a[sortByAttr],
          b[sortByAttr],
          sortParam.direction
        );
        if (compareResult !== 0) {
          return compareResult;
        }
      }
      return 0;
    });
  }

  static sortTreeChildrenByType(
    node: any,
    type: string,
    sortBy: string = 'displayName'
  ): void {
    if (!node?.children?.length) {
      return;
    }

    node.children.forEach((child: any) =>
      SortService.sortTreeChildrenByType(child, type, sortBy)
    );

    if (node.type === type) {
      node.children.sort((left: any, right: any) =>
        (left?.[sortBy] ?? '').localeCompare(right?.[sortBy] ?? '')
      );
    }
  }

  static sort(items: any[], direction: SortDirection, sortBy?: string): any[] {
    return items.sort((a, b) => {
      // Sorty by property or sort list
      let valueA = sortBy ? a[sortBy] : a;
      let valueB = sortBy ? b[sortBy] : b;

      // Handle object comparison - convert to comparable string
      if (
        typeof valueA === 'object' &&
        valueA !== null &&
        typeof valueB === 'object' &&
        valueB !== null
      ) {
        if ('name' in valueA && 'name' in valueB) {
          valueA = valueA.name;
          valueB = valueB.name;
        } else {
          // Fallback: convert to JSON string for comparison
          valueA = JSON.stringify(valueA);
          valueB = JSON.stringify(valueB);
        }
      }

      // Lowercase strings
      valueA = typeof valueA === 'string' ? valueA.toLowerCase() : valueA;
      valueB = typeof valueB === 'string' ? valueB.toLowerCase() : valueB;

      return SortService.compare(valueA, valueB, direction);
    });
  }

  private static compare(
    valueA: any,
    valueB: any,
    direction: SortDirection
  ): number {
    let comparatorResult = 0;
    if (valueA != null && valueB != null) {
      if (valueA > valueB) {
        comparatorResult = 1;
      } else if (valueA < valueB) {
        comparatorResult = -1;
      }
    } else if (valueA != null) {
      comparatorResult = 1;
    } else if (valueB != null) {
      comparatorResult = -1;
    }
    return comparatorResult * (direction === SortDirection.Ascending ? 1 : -1);
  }
}
